import React, { useEffect, useState } from "react";
import { Typography, List, ListItem, Collapse } from "@material-ui/core";
import { getStyles } from "../util/getStyles";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
const Toggle = (props) => {
  const [list, setList] = useState([{}]);
  const [open, setOpen] = useState([true]);
  useEffect(() => {
    setList(props.tabs);
  }, []);

  const handleOpen = (index) => {
    const newOpen = [];
    newOpen[index] = !open[index];
    setOpen(newOpen);
  };

  return (
    <List>
      {list.map((listObj, index) => {
        return (
          <div key={listObj._id + index}>
            <ListItem
              onClick={() => handleOpen(index)}
              style={{
                background: "rgb(255,255,255)",
                border: "1px solid rgb(240,240,240)",
                borderRight: "0px",
                borderLeft: "0px",
                borderTop: "0px",
                display: "flex",
                justifyContent: "space-between",
                fontSize: "18px",
              }}
              key={listObj._id}
            >
              <Typography variant="h6">{listObj.tab_title}</Typography>
              {open[index] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open[index]} timeout="auto" unmountOnExit>
              <ListItem
                button
                style={{
                  background: "rgb(255,255,255)",
                  paddingLeft: "2%",
                  paddingTop: 20,
                  paddingBottom: 20,
                  border: "1px solid rgb(240,240,240)",
                  borderRight: "0px",
                  borderLeft: "0px",
                  borderTop: "0px",
                }}
              >
                {ReactHtmlParser(listObj.tab_content)}
              </ListItem>
            </Collapse>
          </div>
        );
      })}
    </List>
  );
};
export default Toggle;
